module.exports = __webpack_public_path__ + "static/media/logo_edis.e11878f4.png";